<script>
  import componentEditorMixin from '@/components/ProductComponents/CreateComponents/componentEditorMixin.js'
  export default {
    name: "RectangleEditor",
    mixins: [componentEditorMixin],
    data() {
      return {
        colorFlag: 0,
        borderStyleList: [
          {
            value: 'dotted',
            name: '点线'
          },
          {
            value: 'solid',
            name: '实线'
          },
          {
            value: 'dashed',
            name: '虚线'
          },
          {
            value: 'double',
            name: '双边'
          },
          {
            value: 'none',
            name: '无'
          },
        ],
        recDirectionList: [
          {
            value: 'turn',
            name: '旋转90度'
          },
          {
            value: 'none',
            name: '无'
          }
        ],
        directionList: [
          {
            value: 'upToDown',
            name: '上-->下'
          },
          {
            value: 'downToUp',
            name: '下-->上'
          }
        ],
        extendDirectionList:[
          {
            value: 'left',
            name: '向左'
          },
          {
            value: 'right',
            name: '向右'
          },
          {
            value: 'top',
            name: '向上'
          },
          {
            value: 'bottom',
            name: '向下'
          },
        ],
        formList: [
          'RectangleForm',
        ],
        ruleList: {
          rectangleColor: [
            {
              required: true,
              message: '请选择矩形颜色'
            }
          ],
          borderStyle:[
            {
              required: true,
              message: '请选择边框样式'
            }
          ],
          borderColor:[
            {
              required: true,
              message: '请选择边框颜色'
            }
          ],
          borderWidth: [
            {
              required: true,
              message: '请输入边框宽度'
            },
            // {
            // type: 'number',
            // message: '边框宽度输入数字'
            // }
          ],
        },
      }
    },
    computed: {
      specificForms() {
        return (
          <div class="specificForms">
              <el-collapse-item class="specificForm" title="矩阵效果选项" name="2">
                <template slot="default">
                  <div class="specificForm">
                    <el-form id="RectangleForm" props={{model: this.newSettings}} ref="RectangleForm" rules={this.ruleList} label-style={this.formLabelStyle}
                             hide-required-asterisk={true}>
                      <el-form-item label="延伸方向" prop="extendDirection" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                            value: this.newSettings.extendDirection,
                            type: 'radio',
                            radioList: this.extendDirectionList,
                            varList: this.varList,
                            varJson: this.varJson,
                            showEditButton: false,
                          }}}{...{on: {
                            'input': val => {
                              this.newSettings.extendDirection = val
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>

                      <el-form-item label="延伸值" prop="extendValue" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                            value: this.newSettings.extendValue,
                            type: 'input',
                            varList: this.varList,
                            varJson: this.varJson,
                            showEditButton: true,
                            label:"延伸值",
                          }}}{...{on: {
                            'input': val => {
                              this.newSettings.extendValue = val;
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="填充颜色" prop="rectangleColor" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.rectangleColor,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"填充颜色",
                          }}}{...{on: {
                            'input': val=>{
                              this.rectangleColorChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="背景颜色" prop="backColor" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                            value: this.newSettings.backColor,
                            type: 'color',
                            varList: this.varList,
                            varJson: this.varJson,
                            showEditButton: true,
                            label:"背景颜色",
                          }}}{...{on: {
                            'input': val=>{
                              this.newSettings.backColor = val;
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>

                      <el-form-item label="边框类型" prop="borderStyle" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.borderStyle,
                          type: 'radio',
                          radioList: this.borderStyleList,
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"边框类型",
                          }}}{...{on: {
                            'input': val=>{
                              this.borderStyleChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="边框颜色" prop="borderColor" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.borderColor,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"边框颜色",
                          }}}{...{on: {
                            'input': val=>{
                              this.borderColorChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="边框宽度" prop="borderWidth" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.borderWidth,
                          type: 'input',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"边框宽度",
                          }}}{...{on: {
                            'input': val=>{
                              this.borderWidthChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="闪烁" prop="flash" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.flash,
                          type: 'switch',
                          varList: this.varList,
                          varJson: this.varJson,
                        showEditButton: true,
                            label:"闪烁",
                          }}}{...{on: {
                            'input': val=>{
                              this.rectangleFlash(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                    </el-form>
                  </div>
                </template>
              </el-collapse-item>
          </div>
        )
      }
    },
    methods:{
      rectangleColorChange(val){
        this.styleMergeObj = {
          ...this.styleMergeObj,
          'background-color': val
        }
        this.newSettings.rectangleColor = val
      },
      borderStyleChange(val){
        // var tmp
        // if(val == '点线') tmp = 'dotted'
        // else if(val == '实线') tmp = 'solid'
        // else if(val == '虚线') tmp = 'dashed'
        // else if(val == '双边') tmp = 'double'
        // else tmp = 'none'
        this.styleMergeObj = {
          ...this.styleMergeObj,
          'border-style': val
        }
        this.newSettings.borderStyle = val
      },
      borderColorChange(val){
        this.styleMergeObj = {
          ...this.styleMergeObj,
          'border-color': val
        }
        this.newSettings.borderColor = val
      },
      borderWidthChange(val){
        this.styleMergeObj = {
          ...this.styleMergeObj,
          'border-width': val + 'px'
        }
        this.newSettings.borderWidth = val
      },
      //矩阵闪烁
      rectangleFlash(val){
        this.newSettings.flash = val
        console.log(this.newSettings.flash)
        if(val === true){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'animation-play-state' : 'running',
          }
        }
        else if(val === false){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'animation-play-state' : 'paused',
          }
        }
      },
      //矩阵显示
      rectangleState(val,attr){
        this.$set(this.newSettings, attr, val)
      },
    }
  }
</script>

<style lang="less">
  .rectangleEditor {
    .singleSelect {
      height: 30px;
      line-height: 30px;
      width: 100%;
      border-radius: 5px;
      padding: 0 10px;
    }
  }
</style>
